import { api } from '../../api'
import { createDateRangeParams } from '../utils'

export const npuApi = api
  .enhanceEndpoints({
    addTagTypes: ['nonProdCards'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getNonProdCards: builder.query({
        providesTags: ['nonProdCards'],
        query: ({ dateStart, dateEnd }) => {
          const params = createDateRangeParams({ dateStart, dateEnd })

          return {
            url: '/npu',
            method: 'GET',
            params,
          }
        },
      }),
      createNonProdCard: builder.mutation({
        invalidatesTags: ['nonProdCards'],
        query: ({ nonProdBody }) => {
          return {
            url: '/npu',
            method: 'POST',
            body: nonProdBody,
          }
        },
      }),
      updateNonProdCard: builder.mutation({
        invalidatesTags: ['nonProdCards'],
        query: ({ groupId, nonProdBody }) => {
          return {
            url: `/npu/group/${groupId}`,
            method: 'PATCH',
            body: nonProdBody,
          }
        },
      }),
      deleteNonProdCard: builder.mutation({
        invalidatesTags: ['nonProdCards'],
        query: ({ groupId }) => {
          return {
            url: `/npu/group/${groupId}`,
            method: 'DELETE',
          }
        },
      }),
    }),
  })

export const {
  useGetNonProdCardsQuery,
  useCreateNonProdCardMutation,
  useUpdateNonProdCardMutation,
  useDeleteNonProdCardMutation,
} = npuApi
